(function() {
  var Storage,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Storage = App.loadClass('core::Storage');

  exports.RxOptions = (function(superClass) {
    extend(RxOptions, superClass);

    function RxOptions(options) {
      if (options == null) {
        options = {};
      }
      RxOptions.__super__.constructor.call(this);

      /*
          So this is kiiiind of a weird hack. In order to get data into the Rx angular
          controller, we need some way to access it... either pass as state params: not what
          we want, or provide some data that can be injected into the angular controller. So,
          we're adding this RxStorage object to window, so when the planting-rx state gets resolved,
          we'll yoink that object down from window, and inject it to the controller
       */
      this.store('field', options.field.id);
      this.store('field_name', options.field.field_name);
      this.store('year', options.year);
      this.store('crop', options.crop);
      this.store('crop_name', options.crop_name);
      this.store('brands', options.brands);
      this.store('refuge', options.refuge);
      this.store('dual_hybrid', options.dual_hybrid);
      this.store('solver_variables', options.solver_variables);
      this.store('spp', options.spp);
      this.store('spp_id', options.spp_id);
      this.store('fsr_id', options.field.fsr_id);
      this.store('yield_goal', options.yield_goal);
      this.store('planter', options.planter);
      this.store('from_state', options.from_state);
      return this;
    }

    return RxOptions;

  })(Storage);

}).call(this);
